function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeCaeModel48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 17.4999,
    x2: 29.5,
    y2: 29.4999,
    gradientTransform: "matrix(1.50318, 0, 0, 1.50318, -11.837333, -21.881345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDE6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#C6E2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5419,
    style: {
      stopColor: "#B3D8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    style: {
      stopColor: "#93C7D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CC3D2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "41.527 13.443 23.488 2.921 5.45 13.443 23.488 23.964",
    style: {}
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.25,
    y1: 25.7499,
    x2: 25.75,
    y2: 42.2499,
    gradientTransform: "matrix(1.50318, 0, 0, 1.50318, -11.837333, -21.881345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD7E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1588,
    style: {
      stopColor: "#A4D0DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7059,
    style: {
      stopColor: "#80BCCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73B4C8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_4_)",
    points: "5.45 13.443 5.45 34.487 23.488 45.009 23.488 23.964",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3C91AF",
    points: "23.488 23.964 23.488 45.009 41.527 34.487 41.527 13.443",
    style: {}
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "5.45 13.443 23.488 23.964 41.527 13.443",
    style: {}
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    points: "5.45 23.964 23.488 34.487 41.527 23.964",
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#3C91AF",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.488,
    y1: 23.964,
    x2: 23.488,
    y2: 45.009,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#147391",
    strokeMiterlimit: 10,
    d: "M 23.488 2.921 L 5.45 13.443 L 5.45 34.487 L 23.488 45.009 L 41.527 34.487 L 41.527 13.443 L 23.488 2.921 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    strokeMiterlimit: 10,
    points: "14.469 39.748 14.469 18.703 32.507 8.182",
    style: {}
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#147391",
    strokeMiterlimit: 10,
    points: "14.469 8.182 32.507 18.703 32.507 39.748",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 23.488,
    cy: 23.964,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 5.45,
    cy: 13.443,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 14.469,
    cy: 8.182,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 23.488,
    cy: 13.443,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 23.488,
    cy: 2.921,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 32.507,
    cy: 8.182,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 23.488,
    cy: 34.487,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 23.488,
    cy: 45.009,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 14.469,
    cy: 18.703,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 14.469,
    cy: 29.226,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 5.45,
    cy: 23.964,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 14.469,
    cy: 39.748,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 5.45,
    cy: 34.487,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 32.507,
    cy: 39.748,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 32.507,
    cy: 29.226,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 32.507,
    cy: 18.703,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 41.527,
    cy: 34.487,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 41.527,
    cy: 23.964,
    r: 2.255,
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0F0F0",
    stroke: "#147391",
    cx: 41.527,
    cy: 13.443,
    r: 2.255,
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeCaeModel48);
export default __webpack_public_path__ + "static/media/typeCAEModel48.589fa3d0197e1d446657a1a9f2151032.svg";
export { ForwardRef as ReactComponent };